import { RefObject, useEffect } from 'react';

type KeyMap = {
    [key: string]: RefObject<HTMLElement>;
};

const useFieldFocus = (keyMap: KeyMap) => {
    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            for (const [key, ref] of Object.entries(keyMap)) {
                if (e.altKey && e.key === key) {
                    e.preventDefault();
                    ref.current?.focus();
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [keyMap]);
};

export default useFieldFocus;
